



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseDocument } from './../entities/basedocument.entity';
@Injectable()
export class DocumentEndpoint extends BaseEndpoint
{
    constructor(api: APIGatewayService) {super("Document", api);}
	

    public  GetDocument(documentNumber: number, documentType: number) : Observable<BaseEntityResponse<BaseDocument>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetDocument',  {documentNumber: documentNumber, documentType: documentType} );
    }
    public GetDocumentForPdf(documentNumber: number, documentType: number): Observable<BaseEntityResponse<BaseDocument>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetDocumentForPdf', { documentNumber: documentNumber, documentType: documentType });
    }
}

